import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'
import { Icon } from 'components/patterns'
import {
  StyledDragHandle,
  StyledDragItem,
  IconBox,
  IndexBox,
  ListItem,
} from './DragItem.style'

// TODO: rename index to more appropriate name (position?)
const DragItem = forwardRef(
  (
    {
      className,
      index,
      hasMoved,
      isDraggable,
      isDragging,
      children,
      isSolenoidItem,
      dataTestId,
    },
    ref
  ) => (
    <StyledDragItem
      className={classNames(className, 'drag-item')}
      ref={ref}
      hasMoved={hasMoved}
      isDragging={isDragging}
      data-testid="drag-item"
    >
      <ListItem className={classNames(className, 'drag-item-list')}>
        <StyledDragHandle
          className={classNames(className, 'drag-item-handle')}
          data-test-id={dataTestId}
          isDraggable={isDraggable}
        >
          {isDraggable ? (
            <IconBox>
              <Icon icon="menu" style={{ fontSize: '8px' }} />
            </IconBox>
          ) : (
            <div style={{ width: 18 }} />
          )}
          {index && (
            <IndexBox>
              <span>
                {index}
                {isSolenoidItem && !isDraggable ? '.' : ''}
              </span>
            </IndexBox>
          )}
        </StyledDragHandle>

        {children}
      </ListItem>
    </StyledDragItem>
  )
)

DragItem.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  index: PropTypes.number,
  hasMoved: PropTypes.bool,
  isDraggable: PropTypes.bool,
  dragging: PropTypes.bool,
  isDragging: PropTypes.bool,
  isSolenoidItem: PropTypes.bool,
  dataTestId: PropTypes.string,
}

export default DragItem
